import React from 'react'
import moment from 'moment'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Caption from 'components/Luxkit/Typography/Caption'
import { DMY_CASUAL_FORMAT } from 'constants/dateFormats'
import Group from 'components/utils/Group'

interface Props {
  bookByDate: string;
  travelByDate: string;
}

export function BnblPackageDates(props: Props) {
  const { bookByDate, travelByDate } = props

  return (
    <Group direction="vertical" gap={8} tabletGap={16}>
      <BodyText variant="medium">This will secure the offer and give you the flexibility to choose your travel dates at a later time.</BodyText>
      <Group direction="vertical" gap={8}>
        <BodyText variant="medium">
          Please ensure you book your dates by&nbsp;<BodyText as="span" weight="bold" variant="medium"> {moment(bookByDate).format(DMY_CASUAL_FORMAT)}</BodyText>&nbsp;
          and travel by&nbsp;<BodyText as="span" weight="bold" variant="medium">{moment(travelByDate).format(DMY_CASUAL_FORMAT)}</BodyText>.*
        </BodyText>
        <Caption colour="neutral-three" variant="medium">*Subject to availability and seasonal surcharges.</Caption>
      </Group>
    </Group>
  )
}
